import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from './routes/privateRoute';
import PublicRoute from './routes/publicRoute';

import Users from './pages/users/index'
import AddUsers from './pages/users/add'
import EditUser from './pages/users/edit'

import Categories from './pages/categoriers';
import CreateCategories from './pages/categoriers/create';
import EditCategories from './pages/categoriers/edit';

import Comments from './pages/comments/indexTable.jsx';

import Galleries from './pages/galleries';


import ViewGallery from './pages/galleries/view';
import CreateGallery from './pages/galleries/create';
import Setting from './pages/profile/setting';
import Discounts from './pages/discounts';
import CreateDiscount from './pages/discounts/create';
import EditDiscounts from './pages/discounts/edit';
import Orders from './pages/orders';
import Notifications from './pages/notifications';



import './style/App.scss';
import './style/index.scss';
import Workshops from './pages/workshop';
import CreateWorkshop from './pages/workshop/create';
import EditWorkshop from './pages/workshop/edit';
import Blogs from './pages/blogs';
import CreateBlogs from './pages/blogs/create';
import EditBlogs from './pages/blogs/edit';
import Kavenegar from './pages/kavenegar';
import CreateTemplate from './pages/kavenegar/create';
import EditTemplate from './pages/kavenegar/edit';
import CreateNotification from './pages/notifications/create';
import EditNotification from './pages/notifications/edit';
import Login from './pages/auth/login';
import Dashboard from './pages/dashboard';
import ViewBlog from './pages/blogs/view';
import ViewCategory from './pages/categoriers/view';
import ViewUser from './pages/users/view';
import EditWebsite from './pages/website/edit';
import Courses from './pages/course';
import CreateCourse from './pages/course/create';
import EditCourse from './pages/course/edit';


function App() {
    return (
        <BrowserRouter >
            <Routes>

                <Route path="/auth/login" element={
                    // <PublicRoute >
                        <Login />
                    // </PublicRoute>
                } />

                <Route path="*" element={
                    <PrivateRoute>
                        <Navigate to={"/admin/dashboard"} />
                    </PrivateRoute>
                } />


                <Route path="/admin/dashboard" element={
                    <PrivateRoute >
                        <Dashboard />
                    </PrivateRoute>
                } />

                <Route path="/admin/website/info" element={
                    <PrivateRoute >
                        <EditWebsite />
                    </PrivateRoute>
                } />


                <Route path="/admin/users" element={
                    <PrivateRoute >
                        <Users />
                    </PrivateRoute>
                } />
                <Route path="/admin/users/create" element={
                    <PrivateRoute >
                        <AddUsers />
                    </PrivateRoute>
                } />
                <Route path="/admin/users/edit/:user_id" element={
                    <PrivateRoute >
                        <EditUser />
                    </PrivateRoute>
                } />
                <Route path="/admin/users/:user_id" element={
                    <PrivateRoute >
                        <ViewUser />
                    </PrivateRoute>
                } />



                <Route path="/admin/categories" element={
                    <PrivateRoute >
                        <Categories />
                    </PrivateRoute>
                } />
                <Route path="/admin/categories/create" element={
                    <PrivateRoute >
                        <CreateCategories />
                    </PrivateRoute>
                } />
                <Route path="/admin/categories/edit/:category_id" element={
                    <PrivateRoute >
                        <EditCategories />
                    </PrivateRoute>
                } />
                <Route path="/admin/categories/:category_id" element={
                    <PrivateRoute >
                        <ViewCategory />
                    </PrivateRoute>
                } />


                <Route path="/admin/comments" element={
                    <PrivateRoute >
                        <Comments />
                    </PrivateRoute>
                } />


                <Route path="/admin/galleries" element={
                    <PrivateRoute >
                        <Galleries />
                    </PrivateRoute>
                } />
                <Route path="/admin/galleries/create" element={
                    <PrivateRoute >
                        <CreateGallery />
                    </PrivateRoute>
                } />
                <Route path="/admin/galleries/edit/:gallery_id" element={
                    <PrivateRoute >
                        <ViewGallery />
                    </PrivateRoute>
                } />

                <Route path="/admin/profile/setting" element={
                    <PrivateRoute >
                        <Setting />
                    </PrivateRoute>
                } />


                <Route path="/admin/discounts" element={
                    <PrivateRoute >
                        <Discounts />
                    </PrivateRoute>
                } />
                <Route path="/admin/discounts/create" element={
                    <PrivateRoute >
                        <CreateDiscount />
                    </PrivateRoute>
                } />
                <Route path="/admin/discounts/edit/:discount_id" element={
                    <PrivateRoute >
                        <EditDiscounts />
                    </PrivateRoute>
                } />


                <Route path="/admin/orders" element={
                    <PrivateRoute >
                        <Orders />
                    </PrivateRoute>
                } />


                <Route path="/admin/notifications" element={
                    <PrivateRoute >
                        <Notifications />
                    </PrivateRoute>
                } />
                <Route path="/admin/notifications/create" element={
                    <PrivateRoute >
                        <CreateNotification />
                    </PrivateRoute>
                } />
                <Route path="/admin/notifications/edit/:notification_id" element={
                    <PrivateRoute >
                        <EditNotification />
                    </PrivateRoute>
                } />


                <Route path="/admin/workshop" element={
                    <PrivateRoute >
                        <Workshops />
                    </PrivateRoute>
                } />
                <Route path="/admin/workshop/create" element={
                    <PrivateRoute >
                        <CreateWorkshop />
                    </PrivateRoute>
                } />
                <Route path="/admin/workshop/edit/:workshop_id" element={
                    <PrivateRoute >
                        <EditWorkshop />
                    </PrivateRoute>
                } />

                <Route path="/admin/course" element={
                    <PrivateRoute >
                        <Courses />
                    </PrivateRoute>
                } />
                <Route path="/admin/course/create" element={
                    <PrivateRoute >
                        <CreateCourse />
                    </PrivateRoute>
                } />
                <Route path="/admin/course/edit/:course_id" element={
                    <PrivateRoute >
                        <EditCourse />
                    </PrivateRoute>
                } />

                <Route path="/admin/blogs" element={
                    <PrivateRoute >
                        <Blogs />
                    </PrivateRoute>
                } />
                <Route path="/admin/blogs/create" element={
                    <PrivateRoute >
                        <CreateBlogs />
                    </PrivateRoute>
                } />
                <Route path="/admin/blogs/edit/:blog_id" element={
                    <PrivateRoute >
                        <EditBlogs />
                    </PrivateRoute>
                } />
                <Route path="/admin/blogs/:blog_id" element={
                    <PrivateRoute >
                        <ViewBlog />
                    </PrivateRoute>
                } />


                <Route path="/admin/kavenegar" element={
                    <PrivateRoute >
                        <Kavenegar />
                    </PrivateRoute>
                } />
                <Route path="/admin/kavenegar/create" element={
                    <PrivateRoute >
                        <CreateTemplate />
                    </PrivateRoute>
                } />
                <Route path="/admin/kavenegar/edit/:kavenegar_id" element={
                    <PrivateRoute >
                        <EditTemplate />
                    </PrivateRoute>
                } />

            </Routes>
        </BrowserRouter>
    )
}

export default App;
